import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import CheckIcon from '../assets/images/subscription/successful-icon.svg';

const SubscriptionSuccessModal = ({ show, handleClose, planName }) => {
  const navigate = useNavigate();

  const handleDone = () => {
    handleClose();
    navigate('/');
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      className="subscription-success-modal"
    >
      <Modal.Body>
        <div className="success-icon">
          <img src={CheckIcon} alt="" />
        </div>
        <h3>Payment Successful!</h3>
        <p>
          Your payment has been processed successfully and your subscription to the {planName} plan is
          now active. You can start exploring all the features included in your subscription.
        </p>
        <Button className="custom-bttn style-3 mx-auto" onClick={handleDone}>
          Close
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default SubscriptionSuccessModal;
